import { useState, useRef, useCallback } from 'react';

export type SaveStatus = 'idle' | 'saving' | 'saved' | 'error';

export function useSaveIndicator() {
  const [saveStatus, setSaveStatus] = useState<SaveStatus>('idle');
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const debounceRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const debouncedSave = useCallback(
    (saveFn: () => void | Promise<void>) => {
      // Clear existing debounce
      if (debounceRef.current) clearTimeout(debounceRef.current);
      if (timerRef.current) clearTimeout(timerRef.current);

      setSaveStatus('saving');

      debounceRef.current = setTimeout(async () => {
        try {
          await saveFn();
          setSaveStatus('saved');
          timerRef.current = setTimeout(() => {
            setSaveStatus('idle');
          }, 2000);
        } catch {
          setSaveStatus('error');
          timerRef.current = setTimeout(() => {
            setSaveStatus('idle');
          }, 3000);
        }
      }, 1500);
    },
    []
  );

  return { saveStatus, debouncedSave };
}
